import { Component, ElementRef, OnDestroy, OnInit, QueryList, Renderer2, ViewChildren } from "@angular/core"
import { AngularFirestore, AngularFirestoreDocument } from "@angular/fire/firestore"
import { Observable, Subscription } from "rxjs"
import { AnalyticsEvent, AnalyticsService } from "@aaa-web/app/core/services/analytics.service"
import firebase from "firebase/app"
import Timestamp = firebase.firestore.Timestamp
import { MetaWindow } from "@aaa-web/app/core/interfaces/window.interface"

interface RateLimitEntry {
  source: string,
  messageId: string,
  timeInitial: Timestamp,
  timeLastSent: Timestamp,
  timesLimited: number,
  messageBodies: {
    body: string,
    time: firebase.firestore.Timestamp,
  }[]
}

interface RateLimitDoc {
  rateControlList: RateLimitEntry[]
}

@Component({
  selector: "aaa-notification",
  templateUrl: "./notification.component.html"
})
export class NotificationComponent implements OnInit, OnDestroy {
  @ViewChildren("collapsedWrapper") collapsedWrapper: QueryList<ElementRef>
  @ViewChildren("collapsedElement") collapsedElement: QueryList<ElementRef>
  entries: RateLimitEntry[]
  notificationRef: AngularFirestoreDocument<RateLimitDoc>
  notification$: Observable<RateLimitDoc>
  notificationSubscription: Subscription
  window: MetaWindow

  constructor(
    private afs: AngularFirestore,
    private analyticsService: AnalyticsService,
    private renderer: Renderer2,
    public domWindow: Window,
  ) {
    this.window = domWindow as unknown as MetaWindow
  }

  ngOnInit(): void {
    this.entries = []
    this.notificationRef = this.afs
      .collection("wss-aaa-web")
      .doc(this.window["metaData"].clubId)
      .collection("apps")
      .doc("notification")
      .collection("rateControlList")
      .doc("list")

    this.notification$ = this.notificationRef.valueChanges()
    this.notificationSubscription = this.notification$
      .subscribe(rateLimitDoc => {
        if (rateLimitDoc && rateLimitDoc.rateControlList) {
          // this.entries = JSON.stringify(docData.rateControlList, null, 2);
          this.entries = rateLimitDoc.rateControlList
            .sort((a, b) => a.timeInitial?.seconds - b.timeInitial?.seconds)

          this.entries.forEach(entry => {
            const timeLimit = 14 * 24 * 60 * 60 // 14 days
            const timeNow = new Date().getTime() / 1000
            const timeLastSent = entry.timeLastSent?.seconds
            if (timeNow - timeLastSent > timeLimit) {
              this.resetRateLimit(entry.source, entry.messageId, true)
            }
          })
        }
      })

    const eventCustomElement: AnalyticsEvent = {
      eventCategory: "Custom Element",
      eventAction: "Supported",
      eventLabel: "<aaa-notification>" + window.location.origin + window.location.pathname,
      eventValue: 1
    }
    this.analyticsService.sendEvent(eventCustomElement)
  }

  ngOnDestroy(): void {
    this.notificationSubscription.unsubscribe()
  }

  toggleCollapsed(entryIndex: number, index: number): void {
    this.collapsedWrapper.forEach(wrapper => {
      if (wrapper.nativeElement.id === "collapsed-wrapper-" + entryIndex.toString() + "-" + index.toString()) {
        wrapper.nativeElement.classList.forEach(classListItem => {
          if (classListItem === "collapsed") {
            this.renderer.removeClass(wrapper.nativeElement, "collapsed")
          } else {
            this.renderer.addClass(wrapper.nativeElement, "collapsed")
          }
        })
        console.log(wrapper)
        // console.log(wrapper.nativeElement.offsetTop)
        // this.renderer.addClass(wrapper.nativeElement, 'max-height', wrapper.nativeElement.offsetTop + 'px')
        // console.log(element.nativeElement.offsetTop)
        // this.renderer.setStyle(wrapper.nativeElement, 'max-height', '0')
      }
    })
  }

  resetRateLimit(source: string, messageId: string, confirmed: boolean): void {
    if (!confirmed) {
      confirmed = window.confirm("Reset rate limiting for this message?")
    }
    if (confirmed) {
      // console.log(source)
      // console.log(messageId)

      const entries = this.entries.filter(entry => {
        return !(entry.source === source && entry.messageId === messageId)
      })

      this.notificationRef
        .set({ rateControlList: entries }, { merge: false })
        .catch(() => {
          //
        })
    }
  }
}
